export default "__VITE_ASSET__C9UjtBI9__"